import React, { useEffect, useRef } from "react";
import { useForm } from "react-hook-form";
import { useLoader } from "../../../../../hooks/Loader";
import ButtonElement from "../../../../common/ButtonElement";
import DisplayError from "../../../../common/DisplayError";
import { AppContext } from "../../../../core";
import { getOcrData } from "../ocrData";
import DataSection from "./DataSection";
import { getFields } from "./fields";
import Input from "./Input";

export const PersonalDataUpdateOcrResult = (props) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: "onSubmit" });
  const { nameFields, idCardFields, birthFields, addressFields } = getFields(
    props.ocrResult
  );
  const { resolveScreenAction, setApplicationError } =
    React.useContext(AppContext);
  const loader = useLoader(false);
  const unmounted = useRef(false);

  useEffect(() => {
    return () => {
      unmounted.current = true;
    };
  }, []);

  const onSubmit = (data) => {
    loader.setLoading();

    const ocrData = getOcrData(props.ocrResult);
    ocrData.postalCode = data?.postalCode;

    resolveScreenAction(ocrData)
      .then((res) => {
        if (!unmounted.current) {
          loader.setSuccess();
        }
      })
      .catch((e) => {
        loader.setError();
        setApplicationError();
      });
  };

  const retryClickHandler = () => {
    props.setFailedOcrCount((prevCount) => prevCount + 1);
    props.setOcrState("Upload");
  };

  const onInvalid = (errors) => console.error(errors);

  return (
    <>
      <div className="text-center px-4 pt-4">
        <h3 className="text-orange pt-2 ">Validează datele</h3>
      </div>
      <p className="font-italic mb-4">
        Asigură-te că datele din Cartea ta de Identitate corespund cu cele de
        mai jos.
      </p>
      <form onSubmit={handleSubmit(onSubmit, onInvalid)}>
        <DataSection title="Nume și prenume" fields={nameFields} />
        <DataSection title="Date CI" fields={idCardFields} />
        <DataSection
          title="Locul nașterii și data nașterii"
          fields={birthFields}
        />
        <DataSection title="Adresa de domiciliu" fields={addressFields} />
        <div className="row justify-content-start">
          <div className="col-12 col-lg-auto">
            <Input
              name="postalCode"
              placeHolder="Cod poștal"
              type="text"
              label={
                <span>
                  Completează codul poștal<span className="error">*</span>
                </span>
              }
              validationsObject={{
                required: "Completează codul poștal.",
                pattern: {
                  value: /^[0-9]{6}$/,
                  message: "Codul poştal trebuie să aibă 6 cifre.",
                },
              }}
              register={register}
              error={errors.postalCode}
            />
          </div>
        </div>
        <div className="row justify-content-center mt-3">
          <div className="col-12 col-lg-auto">
            <div className="text-center">
              <ButtonElement
                buttonText="Confirmă"
                type="submit"
                fullWidthSm
                disabled={loader.loading}
              />
              <DisplayError
                errorCondition
                errorMessage="Te rugăm să verifici datele introduse."
              />
            </div>
          </div>
          <div className="col-12 col-lg-auto">
            <ButtonElement
              light
              buttonText="Reîncearcă"
              type="button"
              fullWidthSm
              onClick={retryClickHandler}
            />
          </div>
        </div>
      </form>
    </>
  );
};
